var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import clsx from 'clsx';
import React from 'react';
import './UiButton.css';
import { UiFlex } from '../flex/UiFlex';
import { NavLink } from 'react-router-dom';
import { UiLoader } from '../loader/UiLoader';
export function UiButton(_a) {
    var size = _a.size, color = _a.color, variant = _a.variant, fullWidth = _a.fullWidth, isLoading = _a.isLoading, icon = _a.icon, noWrap = _a.noWrap, to = _a.to, toParams = _a.toParams, disabled = _a.disabled, iconCircle = _a.iconCircle, type = _a.type, onClick = _a.onClick, className = _a.className, children = _a.children;
    variant = variant || 'text';
    color = color || 'default';
    size = size || 0;
    disabled = disabled || isLoading;
    to = Object.keys(toParams || {}).reduce(function (path, key) {
        if (path === void 0) { path = ''; }
        return path.replace(":" + key, toParams === null || toParams === void 0 ? void 0 : toParams[key]);
    }, to);
    if (icon && !children) {
        iconCircle = true;
    }
    var props = {
        className: clsx('UiButton', className, iconCircle && "iconCircle", "size-" + size, color && "color-" + color, variant && "variant-" + variant, fullWidth && 'fullWidth', isLoading && 'isLoading', icon && !children && 'icon', noWrap && 'noWrap', disabled && 'disabled'),
        disabled: disabled,
        onClick: onClick,
    };
    var content = (React.createElement(React.Fragment, null,
        isLoading && (React.createElement(UiFlex, { justifyContent: "center", fullWidth: true, className: "loader" },
            React.createElement(UiLoader, { fill: variant === 'filled' ? 'white' : 'black' }))),
        React.createElement(UiFlex, { spacing: 1, justifyContent: "center", className: "button-content" },
            icon,
            children)));
    return to ? (React.createElement(NavLink, __assign({}, props, { to: to }), content)) : (React.createElement("button", __assign({ type: type || 'button' }, props), content));
}
